import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import Heading from '../heading/Heading';
import CTALink from '../forms/elements/CTALink';
import Wrapper from "../wrapper/Wrapper";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { handleInstagram } from './InstagramAPI';
var exampleProps = {
  title: "Social",
  instaname: "CrackerBarrel",
  link: {
    value: {
      href: "https://www.instagram.com/crackerbarrel",
      text: "Follow Us"
    }
  }
};

var InstagramFeed = /*#__PURE__*/function (_React$Component) {
  _inherits(InstagramFeed, _React$Component);

  var _super = _createSuper(InstagramFeed);

  function InstagramFeed() {
    var _this;

    _classCallCheck(this, InstagramFeed);

    _this = _super.call(this);
    _this.state = {
      images: [],
      showItems: 4,
      matches: window.matchMedia("(min-width: 768px)").matches
    };
    return _this;
  }

  _createClass(InstagramFeed, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _this$props$instaname, instaname, images, handler;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props$instaname = this.props.instaname, instaname = _this$props$instaname === void 0 ? exampleProps.instaname : _this$props$instaname;
                _context.next = 3;
                return handleInstagram(instaname);

              case 3:
                images = _context.sent;
                this.setState({
                  images: images
                });

                handler = function handler(e) {
                  return _this2.setState({
                    matches: e.matches
                  });
                };

                window.matchMedia("(min-width: 768px)").addListener(handler);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? exampleProps.title : _this$props$title,
          _this$props$instaname2 = _this$props.instaname,
          instaname = _this$props$instaname2 === void 0 ? exampleProps.instaname : _this$props$instaname2,
          _this$props$link = _this$props.link,
          link = _this$props$link === void 0 ? exampleProps.link : _this$props$link;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "nav-item",
        style: {
          color: '#9c402c',
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement(Heading, {
        level: "3",
        field: {
          value: title
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "foo",
        style: {
          color: '#643618',
          textAlign: 'center',
          padding: '20px'
        }
      }, /*#__PURE__*/React.createElement(Heading, {
        level: "1",
        field: {
          value: "See What We're Up To @".concat(instaname)
        }
      })), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, this.state.matches && this.state.images.slice(0, 8).map(function (imageinfo) {
        return /*#__PURE__*/React.createElement(Col, {
          sm: "3",
          className: "cb-bg-color-white mb-3 mt-3"
        }, /*#__PURE__*/React.createElement(Link, {
          field: {
            value: {
              href: imageinfo.linksrc,
              target: "_blank"
            }
          },
          className: "",
          style: {
            'height': 'auto'
          }
        }, /*#__PURE__*/React.createElement("img", {
          style: {
            width: '100%',
            height: '226px'
          },
          src: imageinfo.imgsrc
        })));
      }), !this.state.matches && this.state.images.slice(0, 4).map(function (imageinfo) {
        return /*#__PURE__*/React.createElement(Col, {
          sm: "3",
          className: "cb-bg-color-white mb-3 mt-3"
        }, /*#__PURE__*/React.createElement(Link, {
          field: {
            value: {
              href: imageinfo.linksrc,
              target: "_blank"
            }
          },
          className: "",
          style: {
            'height': 'auto'
          }
        }, /*#__PURE__*/React.createElement("img", {
          style: {
            width: '100%',
            height: '226px'
          },
          src: imageinfo.imgsrc
        })));
      })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CTALink, {
        linkType: "default",
        alignment: "center",
        ctaLink: link
      }), /*#__PURE__*/React.createElement(Heading, {
        level: "5",
        field: Heading,
        className: "cb-type_title cb-type--center cb-l-margin-medium--bottom"
      })));
    }
  }]);

  return InstagramFeed;
}(React.Component);

export { InstagramFeed as default };
;